//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const startTraining = useStore((state) => state.startTraining);
  const setStartTraining = useStore((state) => state.setStartTraining);

  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.startTraining.title')}</Title>
        <Text className={'description'} size='m' medium style={{ padding: '0px' }}>
          {t('onboarding.startTraining.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={startTraining}
          onChange={(value) => {
            setStartTraining(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'start-training',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'None or relaxed activity'}>
            <span>🧘</span> {t('onboarding.startTraining.options.none')}
          </Option>
          <Option value={'Lifting'}>
            <span>🏋️</span> {t('onboarding.startTraining.options.lifting')}
          </Option>
          <Option value={'Cardio or recreational sports'}>
            <span>🏃‍♀️</span> {t('onboarding.startTraining.options.cardio')}
          </Option>
          <Option value={'Cardio & lifting'}>
            <span>🔥</span> {t('onboarding.startTraining.options.cardioAndLifting')}
          </Option>
          <Option value={'Light activity & walking'}>
            <span>🚶‍♀️</span> {t('onboarding.startTraining.options.lightActivity')}
          </Option>
          <Option value={'Athlete/competitive sports'}>
            <span>🏅</span> {t('onboarding.startTraining.options.athlete')}
          </Option>
          <Option value={'Dance & aerobics'}>
            <span>💃</span> {t('onboarding.startTraining.options.dance')}
          </Option>
          <Option value={'Yoga/Pilates (mindful movement)'}>
            <span>🧘‍♀️</span> {t('onboarding.startTraining.options.yoga')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
